import React, { useEffect, useMemo, useState } from 'react';
import styles from './style.module.css';
import { PageHeader } from '@ant-design/pro-layout';
import { getTripMedia, MediaType, MediaSchema, TripSchema } from 'api/trip-media';
import { VIDEO, IMAGE } from 'constants/media-types.constants';
import { Radio, Spin } from 'antd';
import { MediaDiscoveryItem } from './MediaDiscoveryItem';
import { useParams } from 'react-router-dom';
import { useMediaTypeQuery } from 'hooks/useMediaTypeQuery';

export function TripMediaDiscovery() {
    const { tripId } = useParams<{ tripId: string }>();
    const { mediaType, updateMediaType } = useMediaTypeQuery();
    const [isLoading, setIsLoading] = useState(true);
    const [media, setMedia] = useState<MediaSchema[]>([]);
    const [trip, setTrip] = useState<TripSchema | null>(null);
    const allowedMediaType = useMemo<MediaType>(() => (mediaType === 'video' ? VIDEO : IMAGE), [mediaType]);

    useEffect(() => {
        if (!tripId) return;

        setIsLoading(true);
        getTripMedia(tripId, allowedMediaType)
            .then((result) => {
                setMedia(result.media);
                setTrip(result.trip);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [tripId, allowedMediaType]);

    const noMediaFound = !isLoading && !media.length;

    return (
        <div className='full-page'>
            <PageHeader ghost={false} title={`${trip ? trip.name : 'Trip'} media`}>
                <div className={styles.searchTools}>
                    <Radio.Group
                        className={styles.mediaTypeSelector}
                        buttonStyle='outline'
                        value={mediaType}
                        onChange={(e) => {
                            updateMediaType(e.target.value);
                        }}>
                        <Radio.Button value={'video'}>Videos</Radio.Button>
                        <Radio.Button value={'photo'}>Photos</Radio.Button>
                    </Radio.Group>
                </div>
            </PageHeader>
            <div className='full-page-content'>
                <div className='max-content-width mb-m'>
                    {isLoading ? (
                        <div className={styles.loading}>
                            <Spin />
                        </div>
                    ) : noMediaFound ? (
                        <div className={styles.noResults}>No media found for this trip</div>
                    ) : (
                        <ul className={styles.mediaList}>
                            {media.map((item) => (
                                <li key={item.id}>
                                    <MediaDiscoveryItem media={item} hasTripLink={false} />
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}
